<template>
    <v-dialog ref="dialog" id="successDialog" sub-class="reg-result">
        <template v-slot:title v-if="title">
            <div v-html="title" />
        </template>
        <template>
            <div class="form-desc center" v-html="message" />
            <div class="form__actions center">
                <div @click="onClose" class="btn btn-green btn-close">
                    {{buttonName}}
                </div>
            </div>
        </template>
    </v-dialog>
</template>
<script>
export default {
    props:{
      title:{
          default:'Спасибо!'
      },
      message:{
          default: 'Ваша информация успешно отправлена.\n'
      },
      buttonName:{
          default:'Понятно'
      }
    },
    methods:{
        show() {
            this.$refs.dialog.show();
        },
        onClose(){
            this.$refs.dialog.hide()
        }
    }
}
</script>
<style>
.popup-reg-result {
    .popup__wrap {
        width: 540px;
    }
    .popup__title{
        margin-bottom: 14px;
    }

    .popup__content {
        text-align: center;
        align-items: center;
        gap: 16px;

        .form-desc {
            font-size: 14px;
            margin-bottom: 8px;
            line-height: 120%;
        }

        .form-actions,
        .form__actions {
            width: 100%;
            justify-content: center;
            margin-top: 0;

            .btn {
                flex: initial;
                max-width: 360px;
                width: 100%;
                margin: 0 auto;


                align-items: center;

                border: none;
                border-radius: 4px;

                cursor: pointer;
                display: inline-flex;
                font-weight: 600;
                gap: 8px;
                height: 38px;
                justify-content: center;
                padding: 12px 24px;
                transition: .5s ease;
                -webkit-user-select: none;
                -moz-user-select: none;
                user-select: none;
            }
        }
    }
}
</style>
